import { demutate, mutate, mutationTypes, updateWord } from './mutationUtils';

export const lowercaseSoftMutations = {
  'k': 'g',
  'p': 'b',
  't': 'd',
  'g': 'c\'h',
  'gw': 'w',
  'b': 'v',
  'd': 'z',
  'm': 'v',
};

export const lowercaseSoftConditionalMutations = {
  '*k': 'g',
  '*p': 'b',
  '*t': 'd',
  'g': 'c\'h',
  'gw': 'w',
  'b': 'v',
  'd': 'z',
  'm': 'v',
};

export const lowercaseSoftIncompleteMutations = {
  'k': 'g',
  'p': 'b',
  't': 'd',
  'g': 'c\'h',
  'gw': 'w',
  'b': 'v',
  'm': 'v',
};

const softIncompleteMutations = {
  'k': 'g',
  'p': 'b',
  't': 'd',
  'g': 'c\'h',
  'gw': 'w',
  'b': 'v',
  'm': 'v',
  'K': 'G',
  'P': 'B',
  'T': 'D',
  'G': 'C\'H',
  'GW': 'W',
  'Gw': 'W',
  'B': 'V',
  'M': 'V',
};

const softMutations = {
  ...softIncompleteMutations,
  'd': 'z',
  'D': 'Z',
};

const reverseIncompleteMutations = {
  'g': 'k',
  'b': 'p',
  'd': 't',
  'c\'h': 'g',
  'w': 'gw',
  'v': [ 'b', 'm' ],
  'G': 'K',
  'B': 'P',
  'D': 'T',
  'C\'H': 'G',
  'C\'h': 'G',
  'W': 'GW',
  'V': [ 'B', 'M' ],
};

const reverseMutations = {
  ...reverseIncompleteMutations,
  'z': 'd',
  'Z': 'D',
};

export const provokersSoftMutationsOnly = [
  'da', 'dre', 'a', // prepositions
  'a', 'ne', 'na', // particules verbales
  're', // adverbe
  'daou', 'div', // numéraux
  'pa', // conjonction de subordination
  'holl',
  'hini', 'homan', 'hennezh',
  'aba',
  'war', 'dindan', 'diwar',
  'eme', 'endra',
  'gwall', 'hanter', 'pe', 'ra', 'seul', 'tra',
];

export function applySoftMutations (wordToMutateIdx, words) {

  updateWord(words[ wordToMutateIdx ],
    (word) => {
      mutate(word, softMutations, mutationTypes.SOFT);
    },
    (word) => {
      demutate(word, reverseMutations, mutationTypes.SOFT);
    });
}

export function applyIncompleteSoftMutations (wordToMutateIdx, words) {
  updateWord(words[ wordToMutateIdx ],
    (word) => {
      mutate(word, softIncompleteMutations, mutationTypes.SOFT_INCOMPLETE);
    },
    (word) => {
      demutate(word, reverseIncompleteMutations, mutationTypes.SOFT_INCOMPLETE);
    });
}

export function applyAdjectiveMutations (wordToMutateIdx, words) {
  updateWord(words[ wordToMutateIdx ],
    (word) => {
      mutate(word, softMutations, mutationTypes.SOFT_CONDITIONAL);
    },
    (word) => {
      demutate(word, reverseMutations, mutationTypes.SOFT_CONDITIONAL);
    });
}
